import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { cn } from "@/lib/utils";
import { Check } from "@phosphor-icons/react";

// TODO: Homogenize the fancy and normal checkboxes. cursed solution but we ball
const FancyCheckbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: "default" | "monochrome";
  }
>(({ className, variant = "default", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-6 w-6 shrink-0  border-2 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      variant === "default"
        ? "border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground"
        : "border-foreground data-[state=checked]:bg-transparent data-[state=checked]:text-primary data-[state=checked]:border-primary",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check weight="bold" className="w-4 h-4 font-bold" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
FancyCheckbox.displayName = CheckboxPrimitive.Root.displayName;

export { FancyCheckbox };
